export const VistorStatusTypeArray = ['CHECKED_IN', 'MEETING', 'MEETING_DONE', 'WAIT_LIST']
export type VistorStatusType = typeof VistorStatusTypeArray[number]
